<template>
    <div class="WebDetail">
        <div class="WebDetail-title">
            <Breadcrumb>
                <BreadcrumbItem>{{this.$route.query.accountTypeName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.accountName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.name}}</BreadcrumbItem>
                <BreadcrumbItem to="/network/webMonitor">{{$t('alarms.network.AppService.title')}}</BreadcrumbItem>
            </Breadcrumb>
        </div>
        <Row type="flex" justify="space-between" class="code-row-bg">
            <Col span="6">
                <Card style="height: 480px;">
                    <Row>
                        <Row style="height: 200px;">
                            <Col span="24" style="text-align: center;font-size: 103px;display: block;margin-top: 8px;">
                                <img :src="agwLogo" style="width: 83px;">
                            </Col>
                            <Col style="text-align: center;font-size:18px;">{{this.$route.query.name}}</Col>
                        </Row>
                        
                        <Row style="margin-bottom: 20px;">
                            <Col>{{$t('alarms.network.AppService.description')}}</Col>
                            <Col>---</Col>
                        </Row>
                        <Row>
                            <Col style="margin-bottom: 8px;">{{$t('alarms.network.AppService.appConfig')}}</Col>
                            <Row :gutter="4">
                                <Col span="9">{{ $t('alarms.instance.accountType') }}:</Col>
                                <Col span="15">{{this.$route.query.accountTypeName}}</Col>
                            </Row>
                            <Row :gutter="4">
                                <Col span="9">{{$t('alarms.network.AppService.appPlan')}}:</Col>
                                <Col span="15">{{this.serverFarm}}</Col>
                            </Row>
                            <Row :gutter="4">
                                <Col span="9">{{$t('alarms.network.AppService.resourceGroup')}}:</Col>
                                <Col span="15">{{this.resourceGroup}}</Col>
                            </Row>
                            <Row :gutter="4">
                                <Col span="9">{{$t('alarms.network.AppService.subscriptionID')}}:</Col>
                                <Col span="15">{{this.subscriptionId}}</Col>
                            </Row>
                            <Row :gutter="4">
                                <Col span="9">{{$t('alarms.network.AppService.subscriptionName')}}:</Col>
                                <Col span="15">{{this.subscriptionName}}</Col>
                            </Row>
                        </Row>
                    </Row>
                </Card>
            </Col>
            <Col span="13">
                <Card style="height: 480px;">
                    <ul class="content">
                        <li>
                            <Row>
                                <Col span="12">
                                    <Col span="4">
                                        <Button shape="circle" icon="ios-laptop"></Button>
                                    </Col>
                                    <Col span="20">
                                        <Row>
                                            <Col>{{$t('alarms.network.AppService.appServiceInfo')}}</Col>
                                            <Row class="host">
                                                <Col>
                                                    <ul>
                                                        <li>{{ $t('monitor.web.detail.nameLabel') }}</li>
                                                        <li>{{this.$route.query.name}}</li>
                                                    </ul>
                                                </Col>
                                            </Row>
                                        </Row>
                                    </Col>
                                </Col>
                                <Col span="12">
                                    <Col span="4">
                                        <Button shape="circle" icon="ios-pulse"></Button>
                                    </Col>
                                    <Col span="20">
                                        <Row>
                                            <Col>{{ $t('alarms.common.monitorMessage') }}</Col>
                                            <Row class="host">
                                                <Col>
                                                    <ul>
                                                        <li>{{ $t('alarms.common.monitorItems') }}：</li>
                                                        <li>{{monitoringNum}}{{ $t('alarms.common.count') }}</li>
                                                    </ul>
                                                </Col>
                                                 <Col>
                                                    <a @click="monitorAgw">{{ $t('alarms.common.viewMonitoringOverview') }}</a>
                                                </Col>
                                            </Row>
                                        </Row>
                                    </Col>
                                </Col>
                            </Row>
                        </li>
                        <li>
                            <Row>
                                <Col span="12">
                                    <Col span="4">
                                        <Button shape="circle" icon="ios-medkit-outline"></Button>
                                    </Col>
                                    <Col span="20">
                                        <Row>
                                            <Col>{{ $t('alarms.common.alertRule') }}</Col>
                                            <Row class="host">
                                                <Col>
                                                    <ul>
                                                        <li>{{ $t('alarms.common.alertRule') }}：</li>
                                                        <li>{{alertRuleNum}}</li>
                                                    </ul>
                                                </Col>
                                                <Col>
                                                    <ul>
                                                        <li>{{ $t('alarms.common.untreated') }}：</li>
                                                        <li>{{pendingCaseNum}}</li>
                                                    </ul>
                                                </Col>
                                                 <Col>
                                                    <a @click="alertRule">{{ $t('alarms.common.viewAlarmRules') }}</a>
                                                </Col>
                                            </Row>
                                        </Row>
                                    </Col>
                                </Col>
                            </Row>
                        </li>
                    </ul>
                </Card>
            </Col>
            <Col span="4">
                <Card style="height: 480px;">
                    <Row>
                        <Row style="margin-bottom: 10px;">
                            <Col>{{ $t('alarms.common.tags') }}</Col>
                        </Row>
                        <Row>
                            <Col v-for="(item,index) in tagList" v-bind:key="index">
                                <Tag color="default">{{item.key}} : {{item.value}}</Tag>
                            </Col>
                        </Row>
                    </Row>
                </Card>
            </Col>
        </Row>
    </div>
</template>

<script>
    import utils from '../../../../utils/utils.js'
    export default {
        name: 'WebDetail',
        data(){
            return {
                id:'',
                accountId:'',
                accountTypeName:'',
                accountName:'',
                region:'',
                alertRuleNum:'',
                pendingCaseNum:'',
                monitoringNum:'',
                serverFarm:'',
                resourceGroup:'',
                subscriptionId:'',
                subscriptionName:'',
                agwLogo: require('../../../../../static/images/webService.png'),
                tagList:[]
            }
        },
        mounted () {
            this.queryAppServiceById();
        },
        methods: {
            init:function(){
                this.id = this.$route.query.id;
                this.accountId=this.$route.query.accountId;
                this.region=this.$route.query.region;
                this.accountName=this.$route.query.accountName;
                this.accountTypeName=this.$route.query.accountTypeName;
                this.name=this.$route.query.name;
            },
            // 通过instanceId查询实例
            queryAppServiceById:function(){
                this.$api.resourceAzureAppService.queryAppServiceById({
                    "id":this.$route.query.id
                })
                .then(res => {
                    this.alertRuleNum=res.data.alertRuleNum;
                    this.pendingCaseNum=res.data.pendingCaseNum;
                    this.monitoringNum=res.data.monitoringNum;
                    this.tagList=res.data.tags;
                    this.serverFarm=res.data.serverFarm;
                    this.resourceGroup=res.data.resourceGroup;
                    this.subscriptionId=res.data.subscriptionId;
                    this.subscriptionName=res.data.subscriptionName;
                });
            },               
            // 点击查看监控概览
            monitorAgw: function(){
                this.init();
                this.$router.push({path:'/network/web/',query: {id: this.id,accountId:this.accountId,region:this.region,accountTypeName:this.accountTypeName,accountName:this.accountName,name:this.name}});
            },
            // 点击查看报警规则
            alertRule: function(){
                this.init();
                this.$router.push({path:'/network/webWarning/',query: {id: this.id,accountId:this.accountId,region:this.region,accountTypeName:this.accountTypeName,accountName:this.accountName,name:this.name}});
            }
        }
        
    }
</script>

<style scoped>
    .WebDetail-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 15px 4px;
        font-weight: 600;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
    .host ul
    {
        list-style: none;
        overflow: hidden;
    }
    .host ul li
    {
        float: left;
    }
    .content>li
    {
        margin-bottom: 6px;
        border-bottom: 1px dashed #ccc;
        padding: 12px;
    }
    .content>li:last-child
    {
        border:none;
    }

</style>



// WEBPACK FOOTER //
// src/components/monitor/network/web/WebDetail.vue